import { useState, useEffect } from "react";
import { Menu, X, ChevronRight } from "lucide-react";

const navLinks = [
  { label: "Servicios", href: "#servicios" },
  { label: "Proyectos", href: "#proyectos" },
  { label: "Contacto", href: "#contacto" },
  { label: "Blog", href: "/blog" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 bg-white ${
        scrolled ? "shadow-lg py-2" : "shadow-sm py-3"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center group" data-testid="navbar-logo">
          <img
            src="/assets/logo.png"
            alt="Ms Vision Telecomunicaciones"
            className="h-14 w-auto object-contain group-hover:scale-105 transition-transform duration-300"
          />
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className="text-primary hover:text-accent font-body font-medium text-sm transition-colors duration-300 relative group"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-accent group-hover:w-full transition-all duration-300" />
            </a>
          ))}
          <a
            href="#contacto"
            data-testid="navbar-cta"
            className="bg-accent text-white px-5 py-2.5 rounded-full font-heading font-semibold text-sm flex items-center gap-1 hover:bg-[#0099D6] hover:shadow-[0_0_20px_rgba(0,174,239,0.5)] transition-all duration-300 transform hover:scale-105"
          >
            Contactanos <ChevronRight size={14} />
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden text-primary p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          mobileOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-white px-6 py-4 flex flex-col gap-4 border-t border-gray-100 shadow-lg">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="text-primary hover:text-accent font-body font-medium py-2 transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contacto"
            onClick={() => setMobileOpen(false)}
            className="bg-accent text-white px-5 py-3 rounded-full font-heading font-semibold text-center hover:bg-[#0099D6] transition-colors duration-300"
          >
            Contactanos
          </a>
        </div>
      </div>
    </nav>
  );
};
